import type { Ref, WatchSource } from 'vue';

/**
 * 历史：弹层打开时隐藏自定义 tabbar，避免页内 fixed 遮罩压不过 body 上的底栏。
 *
 * 现状：AppChrome 常驻 body；弹层改为 Teleport + 更高 z-index 盖住底栏，
 * 不再隐藏 tabbar（避免关闭弹层后底栏偶发不恢复）。
 * 保留此 composable 为空操作，避免各调用点大面积删改。
 */
export const useHideTabbarOnOverlay = (
  _visible: WatchSource<boolean> | Ref<boolean>
) => {
  /* no-op：层级覆盖，不藏底栏 */
};
